<script setup lang="ts">
// types
import type { SectionImpactCardsProps } from '@ts-sections/section-impact-cards/interfaces'
// hooks
import { useSectionImpactCards } from '@hooks/sections/section-impact-cards.hook'
// components
import { Button } from '@brighterly/lib-lumee-ui'
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import BlockCardImpact from '@Blocks/BlockCardImpact.vue'
import BlockCardIcon from '@Blocks/BlockCardIcon.vue'

defineOptions({
  name: 'SectionImpactCards',
})

const props = defineProps<{
  section: SectionImpactCardsProps
}>()

const {
  refTitle,
  refButtonText,
  refButtonVariant,
  refHref,
  refMainCard,
  refSideCards,
  getCardMotion,
  handleClickButton,
} = useSectionImpactCards({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-impact-cards"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    color="secondary"
  >
    <div class="section-impact-cards__grid">
      <div
        v-if="refMainCard"
        v-motion="getCardMotion(0)"
        class="section-impact-cards__main"
      >
        <BlockCardImpact :block="refMainCard" />
      </div>

      <ul class="section-impact-cards__side">
        <li
          v-for="(card, index) in refSideCards"
          :key="card.id ?? index"
          v-motion="getCardMotion(index + 1)"
          class="section-impact-cards__side-card"
        >
          <BlockCardIcon
            :block="card"
            desktop-scale-from="desktop"
          />
        </li>
      </ul>
    </div>

    <template
      v-if="refButtonText"
      #bottom
    >
      <a
        class="section-impact-cards__cta"
        :href="refHref"
        @click="handleClickButton"
      >
        <Button
          :view="refButtonVariant"
          size="lg"
          trailing-icon="arrow-right"
          :text="refButtonText"
          tabindex="-1"
        />
      </a>
    </template>
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionImpactCards.scss" />
